
<section class="gps-tools">
  <button appTooltip="Toggle GPS" class="esk-tool" [ngClass]="{'esk-tool--active' : active===true}" (click)="toggleGps()"><i class="fa" [ngClass]="{'fa-toggle-off' : active===false,'fa-toggle-on' : active===true }"></i></button>
  <button appTooltip="Zoom to GPS" class="esk-tool"  [disabled]="active === false" (click)="zoomTo()"><i class="fa fa-search-location" [ngClass]="{'esk-tool--disabled': active === false}" ></i></button>
</section>

